
/** ****************************** Import libs *********************************** */
import { postDataApi, getUserCredentials, postFormDataApi } from "./action";

import { URL_CONSTANTS } from "./urls";


export const postLogin = (params : any) => postDataApi(URL_CONSTANTS.login, params);

export const postGoogleLogin = (params : any) => 
    getUserCredentials(URL_CONSTANTS.googleLogin, params);

export const postForgotPassword = (params : any) => 
    postDataApi(URL_CONSTANTS.forgotPassword, params);

export const postForgotPasswordset = (params : any) => 
    postDataApi(URL_CONSTANTS.forgotPasswordReset, params);

export const  createRoleAndAccess = (params : any) => 
    postDataApi(URL_CONSTANTS.getRoles, params);

export const UsersPostAPI = (params : any) => 
    postDataApi(URL_CONSTANTS.createUser, params);


export const postResetPassword = (params : any) => 
    postDataApi(URL_CONSTANTS.resetPassword, params);

// mapping notes type
export const DeleteMappingNotesTypeAPI = (params : any) => 
    postDataApi(URL_CONSTANTS.deleteappingNotesType, params);

// custom notes type
export const PostCustonNotesTypeAPI = (params : any) =>
    postDataApi(URL_CONSTANTS.customNotesType, params);

export const PostLocationMappingAPI = (params : any) =>
    postDataApi(URL_CONSTANTS.locationMapping, params);

export const UsersUpdateAPI = (params : any) =>
     postDataApi(URL_CONSTANTS.updateUserProfile,params);

// update patient
export const UpdateNotesErrorByPatientDetailsAPI = (params : any) =>
     postDataApi(URL_CONSTANTS.updateNotesErrorByPatientDetails,params);

// ai summarize for notes
export const AiSummarizeForNotesAPI = (params : any) =>
     postDataApi(URL_CONSTANTS.aiSummarizeFornotes,params);

// --------------------------------- Nursing Summary ---------------------

export const NursingSummaryUploadFilesAPI = (formData: FormData) =>
    postFormDataApi(URL_CONSTANTS.nursingSummaryUploadFiles, formData);

export const NursingSummaryTextInputAPI = (params: any) =>
    postDataApi(URL_CONSTANTS.nursingSummaryTextInput, params);

// --------------------------------- eFax ---------------------

export const EfaxPostAPI = (params: any) =>
    postDataApi(URL_CONSTANTS.efaxCurd, params);

// --------------------------------- Auto Delete ---------------------
export const createAutoDeleteConfig = (params: any) =>
    postDataApi(URL_CONSTANTS.autoDeleteConfigs, params);

export const runAutoDeleteNow = (params: any) =>
    postDataApi(URL_CONSTANTS.autoDeleteRunNow, params);
